/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Integrations icon.
 */
export const ICON_CAPABILITY_INTEGRATIONS = (
  <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M14 10H26V14C26 18.4183 29.5817 22 34 22H38V34C38 36.2091 36.2091 38 34 38H14C11.7909 38 10 36.2091 10 34V14C10 11.7909 11.7909 10 14 10ZM17.875 20.5C19.3247 20.5 20.5 19.3247 20.5 17.875C20.5 16.4253 19.3247 15.25 17.875 15.25C16.4253 15.25 15.25 16.4253 15.25 17.875C15.25 19.3247 16.4253 20.5 17.875 20.5ZM20.5 30.125C20.5 31.5747 19.3247 32.75 17.875 32.75C16.4253 32.75 15.25 31.5747 15.25 30.125C15.25 28.6753 16.4253 27.5 17.875 27.5C19.3247 27.5 20.5 28.6753 20.5 30.125ZM30.125 32.75C31.5747 32.75 32.75 31.5747 32.75 30.125C32.75 28.6753 31.5747 27.5 30.125 27.5C28.6753 27.5 27.5 28.6753 27.5 30.125C27.5 31.5747 28.6753 32.75 30.125 32.75Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M13.8592 6.8169C9.96983 6.8169 6.8169 9.96983 6.8169 13.8592V34.1408C6.8169 38.0302 9.96983 41.1831 13.8592 41.1831H34.1408C38.0302 41.1831 41.1831 38.0302 41.1831 34.1409V24.338C41.1831 23.5602 41.8137 22.9296 42.5915 22.9296C43.3694 22.9296 44 23.5602 44 24.338V34.1409C44 39.5859 39.5859 44 34.1408 44H13.8592C8.41409 44 4 39.5859 4 34.1408V13.8592C4 8.41409 8.4141 4 13.8592 4H23.662C24.4398 4 25.0704 4.63058 25.0704 5.40845C25.0704 6.18632 24.4398 6.8169 23.662 6.8169H13.8592Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M34.875 4C32.1826 4 30 6.18261 30 8.875V13.75C30 16.4424 32.1826 18.625 34.875 18.625H39.75C42.4424 18.625 44.625 16.4424 44.625 13.75V8.875C44.625 6.18261 42.4424 4 39.75 4H34.875ZM37.3125 13.75C38.6587 13.75 39.75 12.6587 39.75 11.3125C39.75 9.96631 38.6587 8.875 37.3125 8.875C35.9663 8.875 34.875 9.96631 34.875 11.3125C34.875 12.6587 35.9663 13.75 37.3125 13.75Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
  </svg>
);

/**
 * Integrations icon (dark).
 */
export const ICON_CAPABILITY_INTEGRATIONS_DARK = (
  <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M14 10H26V14C26 18.4183 29.5817 22 34 22H38V34C38 36.2091 36.2091 38 34 38H14C11.7909 38 10 36.2091 10 34V14C10 11.7909 11.7909 10 14 10ZM17.875 20.5C19.3247 20.5 20.5 19.3247 20.5 17.875C20.5 16.4253 19.3247 15.25 17.875 15.25C16.4253 15.25 15.25 16.4253 15.25 17.875C15.25 19.3247 16.4253 20.5 17.875 20.5ZM20.5 30.125C20.5 31.5747 19.3247 32.75 17.875 32.75C16.4253 32.75 15.25 31.5747 15.25 30.125C15.25 28.6753 16.4253 27.5 17.875 27.5C19.3247 27.5 20.5 28.6753 20.5 30.125ZM30.125 32.75C31.5747 32.75 32.75 31.5747 32.75 30.125C32.75 28.6753 31.5747 27.5 30.125 27.5C28.6753 27.5 27.5 28.6753 27.5 30.125C27.5 31.5747 28.6753 32.75 30.125 32.75Z"
      fill="#707070"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M13.8592 6.8169C9.96983 6.8169 6.8169 9.96983 6.8169 13.8592V34.1408C6.8169 38.0302 9.96983 41.1831 13.8592 41.1831H34.1408C38.0302 41.1831 41.1831 38.0302 41.1831 34.1409V24.338C41.1831 23.5602 41.8137 22.9296 42.5915 22.9296C43.3694 22.9296 44 23.5602 44 24.338V34.1409C44 39.5859 39.5859 44 34.1408 44H13.8592C8.41409 44 4 39.5859 4 34.1408V13.8592C4 8.41409 8.4141 4 13.8592 4H23.662C24.4398 4 25.0704 4.63058 25.0704 5.40845C25.0704 6.18632 24.4398 6.8169 23.662 6.8169H13.8592Z"
      fill="#707070"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M34.875 4C32.1826 4 30 6.18261 30 8.875V13.75C30 16.4424 32.1826 18.625 34.875 18.625H39.75C42.4424 18.625 44.625 16.4424 44.625 13.75V8.875C44.625 6.18261 42.4424 4 39.75 4H34.875ZM37.3125 13.75C38.6587 13.75 39.75 12.6587 39.75 11.3125C39.75 9.96631 38.6587 8.875 37.3125 8.875C35.9663 8.875 34.875 9.96631 34.875 11.3125C34.875 12.6587 35.9663 13.75 37.3125 13.75Z"
      fill="#707070"
      fillRule="evenodd"
    />
  </svg>
);
